var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstaGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.837,
    height: 14.837,
    viewBox: "0 0 14.837 14.837",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4592",
    "data-name": "Group 4592",
    transform: "translate(-38.745 -707.083)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4039",
    "data-name": "Path 4039",
    d: "M475.194,215.005a.872.872,0,1,0,.872.873A.872.872,0,0,0,475.194,215.005Zm-3.878,1.119a3.664,3.664,0,1,0,3.664,3.664A3.668,3.668,0,0,0,471.316,216.124Zm0,6.012a2.347,2.347,0,1,1,2.347-2.347A2.35,2.35,0,0,1,471.316,222.135Zm7.394-5.393a4.469,4.469,0,0,0-4.47-4.469h-5.9a4.469,4.469,0,0,0-4.469,4.469v5.9a4.469,4.469,0,0,0,4.469,4.469h5.9a4.47,4.47,0,0,0,4.47-4.469Zm-1.4,5.9a3.069,3.069,0,0,1-3.07,3.069h-5.9a3.069,3.069,0,0,1-3.069-3.069v-5.9a3.069,3.069,0,0,1,3.069-3.069h5.9a3.069,3.069,0,0,1,3.07,3.069Z",
    transform: "translate(-425.128 494.81)",
    fill: "rgba(51,51,51,0.4)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaGrey);
export default __webpack_public_path__ + "static/media/insta-grey.2d956a23048c579df30d4ffd1170aef3.svg";
export { ForwardRef as ReactComponent };